import { Suspense, useEffect, useState } from 'react';
import { RouterProvider } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { router } from './routes/routers';
import ContentDefaultLoader from './components/ContentDefaultLoader';
import { getUserDetails, getUserDetailsStatus } from './redux/userDetails';
import { AppDispatch } from './redux/store';
import { setUserDetails } from './redux/userDetails/userSlice';

function App() {
  const dispatch = useDispatch<AppDispatch>();
  const [isLoading, setIsLoading] = useState(true);
  const userDetailsStatus = useSelector(getUserDetailsStatus);

  useEffect(() => {
    dispatch(getUserDetails());
  }, []);

  useEffect(() => {
    if (userDetailsStatus?.status === 'Pending') {
      setIsLoading(true);
    }
    if (userDetailsStatus?.status === 'Success') {
      const userDetails = userDetailsStatus?.response;
      if (userDetails) {
        dispatch(setUserDetails(userDetails));
      }
      setIsLoading(false);
    }
    if (userDetailsStatus?.status === 'Failed') {
      setUserDetails(null);
      setIsLoading(false);
    }
  }, [userDetailsStatus]);

  if (isLoading) return ContentDefaultLoader();

  return (
    <Suspense fallback={ContentDefaultLoader()}>
      <RouterProvider router={router} />
    </Suspense>
  );
}

export default App;
